
import { toRefs, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter } from 'vue-router'
import { debounce } from '@/utils/common'
import { getTags } from '@/services/common'
import SelectBookModal from '@/views/songs/components/SelectBookModal'
import SelectRelateCoursewareModal from './SelectRelateCoursewareModal.vue'
import { shareModeMap } from '@/utils/dataMap'
import { getOfficialBookInfo } from '@/views/teaching-material/preview/service'
import { message } from 'ant-design-vue'

export default {
  name: 'CoursewareForm',
  components: {
    SelectBookModal,
    SelectRelateCoursewareModal
  },
  props: {
    title: {
      type: String,
      default: '新建课件'
    },
    current: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: true
    },
    isVersionDetail: {
      type: Boolean,
      default: false
    },
    isRelated: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isOnPPT: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onSave', 'cancelRelate', 'updateBookSection', 'onBeforeGoBack'],
  setup (props, { emit }) {
    const router = useRouter()
    const pageState = reactive({
      selectBookModalVisible: false,
      selectRelateCoursewareModalVisible: false,
      isEdit: false
    })
    const formState = computed({
      get: () => props.current,
      set: val => {
        emit('update:current', val)
      }
    })

    const formOpts = reactive({
      subject: [],
      share_mode: Object.keys(shareModeMap).map(i => {
        return { value: parseInt(i), label: shareModeMap[i].name }
      }),
      gradePeriod: [],
      pressVersion: [],
      tags: [],
      bookOpts: {
        showName: '教材名称-章节目录'
      },
      defaultBookOpts: {
        showName: '教材名称-章节目录'
      }
    })

    if (!formState.value.share_mode) {
      formState.value.share_mode = 0
    }

    watch(() => props.current.bookShowName, () => {
      formOpts.bookOpts.showName = props.current.bookShowName ?? formOpts.defaultBookOpts.showName
    })

    watch(() => props.isEdit, (val) => {
      pageState.isEdit = val
    })

    const tagParams = reactive({
      pageSize: 50,
      page: 1,
      keyword: ''
    })

    const getTagsOptions = debounce(async () => {
      const params = { per_page: tagParams.pageSize, current: tagParams.page, keyword: tagParams.keyword }
      const getTagsService = getTags
      formOpts.tags = (await getTagsService(params)).items.map(i => {
        i.label = i.tag
        i.value = i.tag
        return i
      })
    })

    const handleTagSearch = v => {
      tagParams.page = 1
      tagParams.keyword = v
      getTagsOptions()
    }

    const handleSave = () => {
      if (formState.value.relate_coursewares && Object.keys(formState.value.relate_coursewares).length !== 0) {
        const relate_courseware_ids = formState.value.relate_coursewares.map(item => item.id)
        emit('onSave', relate_courseware_ids)
      } else {
        emit('onSave')
      }
    }

    const handleSelectRelateCoursewareSection = (isRelate) => {
      pageState.selectRelateCoursewareModalVisible = false
      const relate_ppts = JSON.parse(localStorage.getItem('relate_ppts'))
      formState.value.relate_coursewares = relate_ppts
      if (isRelate) {
        message.success('关联成功')
        pageState.isEdit = true
      }
    }

    const handleClearRelatedCourseware = () => {
      formState.value.relate_coursewares = {}
      pageState.isEdit = true
    }

    const cancelRelate = (tag) => {
      pageState.isEdit = true
      formState.value.relate_coursewares = formState.value.relate_coursewares.filter((list) => list.id !== tag.id)
      const relate_ppts = formState.value.relate_coursewares
      localStorage.setItem('relate_ppts', JSON.stringify(relate_ppts))
    }

    const handleSelectBookSection = async (value) => {
      pageState.selectBookModalVisible = false
      if (value.values.length > 0) {
        formOpts.bookOpts.showName = value.labels.join('-')
        formState.value.book_section_id = value.values
        if (props.title === '新建课件') {
          const { share_mode } = await getOfficialBookInfo(value.values[0])
          formState.value.share_mode = share_mode || 0
        }
      } else {
        formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      }
    }

    console.log('formState', formState)

    const getOptions = () => {
      getTagsOptions()
    }

    const changeBook = () => {
      if (!props.readOnly) {
        pageState.selectBookModalVisible = true
      }
      pageState.isEdit = true
    }

    const handleRelateCoursewareModalOpen = () => {
      pageState.selectRelateCoursewareModalVisible = true
    }

    const handleRelateCoursewareModalCancel = () => {
      pageState.selectRelateCoursewareModalVisible = false
    }

    const handleGoBack = () => {
      if (props.isOnPPT) {
        emit('onBeforeGoBack')
      } else {
        history.go(-1)
      }
      localStorage.removeItem('relate_ppts')
    }

    onBeforeMount(async () => {
      await getOptions()
      localStorage.removeItem('relate_ppts')
    })

    return {
      handleGoBack,
      changeBook,
      cancelRelate,
      pageState,
      formOpts,
      formState,
      history,
      handleTagSearch,
      ...toRefs(props),
      handleSave,
      handleSelectBookSection,
      handleSelectRelateCoursewareSection,
      handleClearRelatedCourseware,
      handleRelateCoursewareModalOpen,
      handleRelateCoursewareModalCancel
    }
  }
}
